import { render, staticRenderFns } from "./monitoring-snp-new.vue?vue&type=template&id=b2d902f4&"
import script from "./monitoring-snp-new.vue?vue&type=script&lang=js&"
export * from "./monitoring-snp-new.vue?vue&type=script&lang=js&"
import style0 from "./monitoring-snp-new.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports